import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../servicios/api/api.service';
import { AdminFuenteService } from '../../../servicios/adminfuentes/AdminFuente.service';
import { fuenteI } from '../../../modelos/fuentes.interface';
import { SuperI } from '../../../modelos/superintendecia.interface';
import { TipoEntidadI } from '../../../modelos/tipoEntidad.interface';
import { OperacionI } from '../../../modelos/operacionEsta.interface';
import { EstadoEntiI } from '../../../modelos/estadoEntidad.interface';
import { DeptoI } from '../../../modelos/departamento.interface';
import { MuniI } from '../../../modelos/municipio.interface';
import { DireccionNor } from '../../../modelos/direccionNor';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DireccionI } from 'src/app/modelos/direccion';
import { VariableI } from 'src/app/modelos/variable';
import { DivipolaI } from 'src/app/modelos/Divipola';
import { CrearFuenteDto } from 'src/app/modelos/fuentesdtos/CrearFuenteDto';


@Component({
  selector: 'app-nuevafuente',
  templateUrl: './nuevafuente.component.html',
  styleUrls: ['./nuevafuente.component.css']
})
export class NuevafuenteComponent implements OnInit {

  operacionesEstad : OperacionI[];
  superintendencias : VariableI[];
  tiposEntidad : VariableI[];
  departamentos : DivipolaI[];
  Municipios : DivipolaI[];
  nuevaFuente : fuenteI;
  id : BigInteger;
  nit : String;
  idSuper : SuperI;
  idTipoEntidad : TipoEntidadI;
  codEnti : String;
  nombEntidad : String;
  depto : DeptoI;
  muni : MuniI;
  direccion : String;
  telefono : String;
  email : String;
  operacion1 : OperacionI;
  operacion2 : OperacionI;
  idEstado : EstadoEntiI;
  auxSuper : String;
  auxTipo : String;
  auxDepto : Number;
  auxMuni : Number;
  auxOpera : BigInteger;
  auxEstado : BigInteger;
  auxFuenteCHV : Boolean;
  auxFuenteFIVI : Boolean;
  btnguardar : Boolean;
  tempSave : Boolean;
  continuar : Boolean;


  DireccionFinal : string;
  DireccionNormalizada : DireccionNor;

  RespCHVFrom = {
    nombre : "",
    cargo : "",
    telefono : "",
    email : ""
  }

  RespFIVIFrom = {
    nombre : "",
    cargo : "",
    telefono : "",
    email : ""
  }


  NumPrefijoUnoPrueba = new FormControl('',[Validators.required]);
  tipovia = new FormControl('',[Validators.required]);
  numvia : string;
  letravia = new FormControl('',[Validators.required]);
  prefijo = new FormControl('',[Validators.required]);
  cuaduno = new FormControl('',[Validators.required]);
  numpreuno = new FormControl('',[Validators.required]);
  letpre = new FormControl('',[Validators.required]);
  numpredos : string;
  cuaddos = new FormControl('',[Validators.required]);
  complemento = new FormControl('',[Validators.required]);
  acomple : string = '';
  DireccionPrueba : DireccionI;


  @ViewChild('closeModalDireccion') closeModalDireccion: ElementRef;
  @ViewChild('openmodalcargando') openmodalcargando: ElementRef;
  @ViewChild('cerrarmodalcargando') cerrarmodalcargando: ElementRef;
  @ViewChild('openmodalAdminvar') openmodalAdminvar: ElementRef;
  @ViewChild('cerrarmodalAdminvar') cerrarmodalAdminvar: ElementRef;

  constructor(private router: Router,
              private api: ApiService,
              private adminFuentesService: AdminFuenteService,
              private toastr: ToastrService) { }

  ngOnInit(): void {
    this.btnguardar = false;
    this.auxFuenteCHV = false;
    this.auxFuenteFIVI = false;
    this.tempSave = false;

    this.nuevaFuente = new fuenteI();
    this.nuevaFuente.nit = "";
    this.nuevaFuente.codEnti = "";
    this.nuevaFuente.nombEntidad = "";
    this.nuevaFuente.direccion = "";
    this.nuevaFuente.telefono = "";
    this.auxSuper = "";
    this.auxTipo = "";
    this.auxDepto = 0;
    this.auxMuni = 0;

    this.DireccionFinal = "";
    this.DireccionNormalizada = new DireccionNor;
    this.DireccionPrueba = new DireccionI;


    this.api.getOperacionesEsta().subscribe(data=>{
      this.operacionesEstad = data;
    },error=>{
      console.log(error);
    });

    this.api.getAllSuper().subscribe(data=>{
      this.superintendencias = data;
    },error=>{
      console.log(error);
    });

    this.api.getDeptos().subscribe(data=>{
      this.departamentos = data;
    },error=>{
      console.log(error);
    });

    this.api.getEstadoById(1).subscribe(data=>{
      this.nuevaFuente.idEstado = data;
    },error=>{
      console.log(error);
    });
  }

  getTiposBySupers(codigo){
    this.nuevaFuente.codSuper = codigo;
    this.CodigoTipoEntidad.setValue('');
    this.api.getTiposEntidad(codigo).subscribe(data2=>{
      this.tiposEntidad = data2;
      this.UpdateVariableNuevaFuente();
    },error=>{
      console.log(error);
    });
  }


  getMunicByDepto(cod){
    this.CodigoMpio.setValue('');
    this.api.getMuniByDepto(cod).subscribe(data=>{
      //console.log(data);
      this.Municipios = data;
      this.UpdateVariableNuevaFuente();
    },error=>{
      console.log(error);
    });
    this.api.getdeptoByCod(cod).subscribe(data=>{
      //this.nuevaFuente.depto = data;
    },error=>{
      console.log(error);
    });
  }

  regresarFuentes(){
    this.router.navigate(['fuentes']);
  }

  NormalizandoDirecccion(){
    this.DireccionFinal = "";
  }

  Complemento(){
    this.acomple = this.acomple + " " + this.complemento.value + " ";
  }

  NuevaFuente: CrearFuenteDto= new CrearFuenteDto;

  AuxFuenteCHV= new FormControl(null,[Validators.required]);
  AuxFuenteFIVI= new FormControl(null,[Validators.required]);
  Nit= new FormControl('',[Validators.required,
                            Validators.pattern('[0-9a-zA-Z]*'),
                            Validators.minLength(9),
                            Validators.maxLength(12)]);
	CodigoSuperintendencia= new FormControl('',[Validators.required]);
	CodigoTipoEntidad= new FormControl('',[Validators.required]);
	CodigoEntidad= new FormControl('',[Validators.required, Validators.pattern('[0-9 ]*')]);
	RazonSocial= new FormControl('',[Validators.required]);
	CodigoDepto= new FormControl('',[Validators.required]);
	CodigoMpio= new FormControl('',[Validators.required]);
	Direccion= new FormControl('',[Validators.required]);
	Telefono= new FormControl('',[Validators.required]);
	CodigoEntidadFinanciadora= new FormControl('',[Validators.required]);

	ResponsableChvNombre= new FormControl('',[Validators.required]);
	ResponsableChvCargo= new FormControl('',[Validators.required]);
	ResponsableChvTelefono= new FormControl('',[Validators.required]);
	ResponsableChvCorreo= new FormControl('',[Validators.required, Validators.email]);

  ResponsableInfoChvNombre= new FormControl('',[Validators.required]);
	ResponsableInfoChvCargo= new FormControl('',[Validators.required]);
	ResponsableInfoChvTelefono= new FormControl('',[Validators.required]);
	ResponsableInfoChvCorreo= new FormControl('',[Validators.required, Validators.email]);

	ResponsableFiviNombre= new FormControl('',[Validators.required]);
	ResponsableFiviCargo= new FormControl('',[Validators.required]);
	ResponsableFiviTelefono= new FormControl('',[Validators.required]);
	ResponsableFiviCorreo= new FormControl('',[Validators.required, Validators.email]);

  ResponsableInfoFiviNombre= new FormControl('',[Validators.required]);
	ResponsableInfoFiviCargo= new FormControl('',[Validators.required]);
	ResponsableInfoFiviTelefono= new FormControl('',[Validators.required]);
	ResponsableInfoFiviCorreo= new FormControl('',[Validators.required, Validators.email]);

	TipoViaPrincipal= new FormControl('',[Validators.required]);
	NombreViaPrincipal= new FormControl('',[Validators.required]);
	LetraViaPrincipal= new FormControl('',[Validators.required]);
	Prefijo= new FormControl('',[Validators.required]);
	Cuadrante1= new FormControl('',[Validators.required]);
	NumeroPrefijo1= new FormControl('',[Validators.required]);
	LetraPrefijo= new FormControl('',[Validators.required]);
	NumeroPrefijo2= new FormControl('',[Validators.required]);
	Cuadrante2= new FormControl('',[Validators.required]);
	Komplemento= new FormControl('',[Validators.required]);
	NumeroLetraComplemento= new FormControl('',[Validators.required]);

  checkEmailValidityChv() {
    const atIndex = this.ResponsableChvCorreo.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.ResponsableChvCorreo.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkRespInfoEmailValidityChv() {
    const atIndex = this.ResponsableInfoChvCorreo.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.ResponsableInfoChvCorreo.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkEmailValidityFivi() {
    const atIndex = this.ResponsableFiviCorreo.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.ResponsableFiviCorreo.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkRespInfoEmailValidityFivi() {
    const atIndex = this.ResponsableInfoFiviCorreo.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.ResponsableInfoFiviCorreo.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  VerificarCampos(){

    if ((this.AuxFuenteCHV.hasError('required')&&this.AuxFuenteFIVI.hasError('required'))||(!this.AuxFuenteCHV.value&&!this.AuxFuenteFIVI.value)){
      this.toastr.warning('Seleccionar operación estadística.', 'Advertencia!');
    } else if (this.Nit.hasError('required')){
      this.toastr.warning('Ingresar NIT.', 'Advertencia!');
    } else if (this.Nit.value.length < 9){
      this.toastr.warning('El NIT debe contar con mínimo 9 caracteres.', 'Advertencia!');
    } else if (this.Nit.value.length > 12){
      this.toastr.warning('El NIT debe contar con máximo 12 caracteres.', 'Advertencia!');
    } else if (this.Nit.hasError('pattern')){
      this.toastr.warning('El NIT contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.CodigoSuperintendencia.hasError('required')){
      this.toastr.warning('Seleccionar superintendencia.', 'Advertencia!');
    } else if (this.CodigoTipoEntidad.hasError('required')){
      this.toastr.warning('Seleccionar tipo de entidad.', 'Advertencia!');
    } else if (this.CodigoEntidad.hasError('required')){
      this.toastr.warning('Ingresar código de la entidad.', 'Advertencia!');
    } else if (this.CodigoEntidad.hasError('pattern')){
      this.toastr.warning('Código de la entidad debe ser númerico.', 'Advertencia!');
    } else if (this.CodigoEntidad.value.length < 6||this.CodigoEntidad.value.length > 6){
      this.toastr.warning('Código de la entidad debe tener 6 dígitos.', 'Advertencia!');
    } else if (this.RazonSocial.hasError('required')){
      this.toastr.warning('Ingresar razón social.', 'Advertencia!');
    } else if (this.RazonSocial.value.length < 5){
      this.toastr.warning('Razón social debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.RazonSocial.value.length > 100){
      this.toastr.warning('Razón social debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.CodigoDepto.hasError('required')){
      this.toastr.warning('Seleccionar departamento.', 'Advertencia!');
    } else if (this.CodigoMpio.hasError('required')){
      this.toastr.warning('Seleccionar municipio.', 'Advertencia!');
    } else if (this.Direccion.hasError('required')){
      this.toastr.warning('Ingresar dirección.', 'Advertencia!');
    } else if (this.Direccion.value.length < 10){
      this.toastr.warning('Dirección debe tener mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.Direccion.value.length > 100){
      this.toastr.warning('Dirección debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.Telefono.hasError('required')){
      this.toastr.warning('Ingresar teléfono.', 'Advertencia!');
    } else if (this.Telefono.value.length < 7){
      this.toastr.warning('Teléfono debe tener mínimo 7 caracteres.', 'Advertencia!');
    } else if (this.Telefono.value.length > 22){
      this.toastr.warning('Teléfono debe tener máximo 22 caracteres.', 'Advertencia!');
    }else if (this.CodigoEntidadFinanciadora.hasError('required')){
      this.toastr.warning('Seleccionar código financiador.', 'Advertencia!');
    } else if (this.ResponsableChvNombre.hasError('required')&&this.AuxFuenteCHV.value){
      this.toastr.warning('Ingresar nombre de usuario responsable - CHV', 'Advertencia!');
    } else if (this.ResponsableChvNombre.value.length < 5 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Nombre de usuario responsable - CHV debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.ResponsableChvNombre.value.length > 100 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Nombre de usuario responsable - CHV debe tener máximo 100 caracteres', 'Advertencia!');
    } else if (this.ResponsableChvCargo.hasError('required')&&this.AuxFuenteCHV.value){
      this.toastr.warning('Ingresar cargo de usuario responsable - CHV', 'Advertencia!');
    } else if (this.ResponsableChvCargo.value.length < 5 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Cargo de usuario responsable - CHV debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.ResponsableChvCargo.value.length > 100 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Cargo de usuario responsable - CHV debe tener máximo 100 caracteres', 'Advertencia!');
    } else if (this.ResponsableChvTelefono.hasError('required')&&this.AuxFuenteCHV.value){
      this.toastr.warning('Ingresar teléfono de usuario responsable - CHV', 'Advertencia!');
    }  else if (this.ResponsableChvTelefono.value.length < 7 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Teléfono de usuario responsable - CHV debe tener mínimo 7 caracteres.', 'Advertencia!');
    }  else if (this.ResponsableChvTelefono.value.length > 10 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Teléfono de usuario responsable - CHV debe tener máximo 10 caracteres.', 'Advertencia!');
    } else if ((this.ResponsableChvCorreo.hasError('required'))&&this.AuxFuenteCHV.value){
      this.toastr.warning('Ingresar correo de usuario responsable - CHV', 'Advertencia!');
    } else if ((this.ResponsableChvCorreo.value.length < 5 )&&this.AuxFuenteCHV.value){
      this.toastr.warning('Correo de usuario responsable - CHV debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if ((this.ResponsableChvCorreo.value.length > 40 )&&this.AuxFuenteCHV.value){
      this.toastr.warning('Correo de usuario responsable - CHV debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if ((this.ResponsableChvCorreo.hasError('email')||!this.checkEmailValidityChv())&&this.AuxFuenteCHV.value){
      this.toastr.warning('Correo de usuario responsable - CHV no valido', 'Advertencia!');
    } else if (this.ResponsableInfoChvNombre.hasError('required')&&this.AuxFuenteCHV.value){
      this.toastr.warning('Ingresar nombre del responsable de la información - CHV', 'Advertencia!');
    } else if (this.ResponsableInfoChvNombre.value.length < 5 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Nombre del responsable de la información - CHV debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.ResponsableInfoChvNombre.value.length > 100 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Nombre del responsable de la información - CHV debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.ResponsableInfoChvCargo.hasError('required')&&this.AuxFuenteCHV.value){
      this.toastr.warning('Ingresar cargo del responsable de la información - CHV', 'Advertencia!');
    } else if (this.ResponsableInfoChvCargo.value.length < 5 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Cargo del responsable de la información - CHV debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.ResponsableInfoChvCargo.value.length > 100 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Cargo del responsable de la información - CHV debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.ResponsableInfoChvTelefono.hasError('required')&&this.AuxFuenteCHV.value){
      this.toastr.warning('Ingresar teléfono del responsable de la información - CHV', 'Advertencia!');
    }  else if (this.ResponsableInfoChvTelefono.value.length < 7 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Teléfono del responsable de la información - CHV debe tener mínimo 7 caracteres.', 'Advertencia!');
    }  else if (this.ResponsableInfoChvTelefono.value.length > 10 &&this.AuxFuenteCHV.value){
      this.toastr.warning('Teléfono del responsable de la información - CHV debe tener máximo 10 caracteres.', 'Advertencia!');
    } else if ((this.ResponsableInfoChvCorreo.hasError('required'))&&this.AuxFuenteCHV.value){
      this.toastr.warning('Ingresar correo del responsable de la información - CHV', 'Advertencia!');
    } else if ((this.ResponsableInfoChvCorreo.value.length < 5 )&&this.AuxFuenteCHV.value){
      this.toastr.warning('Correo del responsable de la información - CHV debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if ((this.ResponsableInfoChvCorreo.value.length > 40 )&&this.AuxFuenteCHV.value){
      this.toastr.warning('Correo del responsable de la información - CHV debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if ((this.ResponsableInfoChvCorreo.hasError('email')||!this.checkEmailValidityChv())&&this.AuxFuenteCHV.value){
      this.toastr.warning('Correo del responsable de la información - CHV no valido.', 'Advertencia!');
    } else if (this.ResponsableFiviNombre.hasError('required')&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Ingresar nombre de usuario responsable - FIVI', 'Advertencia!');
    } else if (this.ResponsableFiviNombre.value.length < 5 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Nombre de usuario responsable - FIVI debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.ResponsableFiviNombre.value.length > 100 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Nombre de usuario responsable - FIVI debe tener máximo 100 caracteres', 'Advertencia!');
    } else if (this.ResponsableFiviCargo.hasError('required')&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Ingresar cargo de usuario responsable - FIVI', 'Advertencia!');
    } else if (this.ResponsableFiviCargo.value.length < 5 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Cargo de usuario responsable - FIVI debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.ResponsableFiviCargo.value.length > 100 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Cargo de usuario responsable - FIVI debe tener máximo 100 caracteres', 'Advertencia!');
    } else if (this.ResponsableFiviTelefono.hasError('required')&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Ingresar teléfono de usuario responsable - FIVI', 'Advertencia!');
    }  else if (this.ResponsableFiviTelefono.value.length < 7 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Teléfono de usuario responsable - FIVI debe tener mínimo 7 caracteres.', 'Advertencia!');
    }  else if (this.ResponsableFiviTelefono.value.length > 10 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Teléfono de usuario responsable - FIVI debe tener máximo 10 caracteres.', 'Advertencia!');
    } else if ((this.ResponsableFiviCorreo.hasError('required'))&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Ingresar correo de usuario responsable - FIVI', 'Advertencia!');
    } else if ((this.ResponsableFiviCorreo.value.length < 5 )&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Correo de usuario responsable - FIVI debe tener mínimo 5 caracteres', 'Advertencia!');
    } else if ((this.ResponsableFiviCorreo.value.length > 40 )&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Correo de usuario responsable - FIVI debe tener máximo 40 caracteres', 'Advertencia!');
    } else if ((this.ResponsableFiviCorreo.hasError('email')||!this.checkEmailValidityFivi())&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Correo de usuario responsable - FIVI no valido', 'Advertencia!');
    } else if (this.ResponsableInfoFiviNombre.hasError('required')&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Ingresar nombre del responsable de la información - FIVI', 'Advertencia!');
    } else if (this.ResponsableInfoFiviNombre.value.length < 5 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Nombre del responsable de la información - FIVI debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.ResponsableInfoFiviNombre.value.length > 100 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Nombre del responsable de la información - FIVI debe tener máximo 100 caracteres', 'Advertencia!');
    } else if (this.ResponsableInfoFiviCargo.hasError('required')&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Ingresar cargo del responsable de la información - FIVI', 'Advertencia!');
    } else if (this.ResponsableInfoFiviCargo.value.length < 5 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Cargo del responsable de la información - FIVI debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.ResponsableInfoFiviCargo.value.length > 100 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Cargo del responsable de la información - FIVI debe tener máximo 100 caracteres', 'Advertencia!');
    } else if (this.ResponsableInfoFiviTelefono.hasError('required')&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Ingresar teléfono del responsable de la información - FIVI', 'Advertencia!');
    }  else if (this.ResponsableInfoFiviTelefono.value.length < 7 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Teléfono del responsable de la información - FIVI debe tener mínimo 7 caracteres.', 'Advertencia!');
    }  else if (this.ResponsableInfoFiviTelefono.value.length > 10 &&this.AuxFuenteFIVI.value){
      this.toastr.warning('Teléfono del responsable de la información - FIVI debe tener máximo 10 caracteres.', 'Advertencia!');
    } else if ((this.ResponsableInfoFiviCorreo.hasError('required'))&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Ingresar correo del responsable de la información - FIVI', 'Advertencia!');
    } else if ((this.ResponsableInfoFiviCorreo.value.length < 5 )&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Correo del responsable de la información - FIVI debe tener mínimo 5 caracteres', 'Advertencia!');
    } else if ((this.ResponsableInfoFiviCorreo.value.length > 40 )&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Correo del responsable de la información - FIVI debe tener máximo 40 caracteres', 'Advertencia!');
    } else if ((this.ResponsableInfoFiviCorreo.hasError('email')||!this.checkEmailValidityFivi())&&this.AuxFuenteFIVI.value){
      this.toastr.warning('Correo del responsable de la información - FIVI no valido', 'Advertencia!');
    }
  }

  BTNguardar(){
    if(
      (this.AuxFuenteCHV.hasError('required')&&this.AuxFuenteFIVI.hasError('required'))||
      (!this.AuxFuenteCHV.value&&!this.AuxFuenteFIVI.value)||
      this.Nit.hasError('required')||
      this.Nit.value.length < 9||
      this.Nit.value.length > 12||
      this.Nit.hasError('pattern')||
      this.CodigoSuperintendencia.hasError('required')||
      this.CodigoTipoEntidad.hasError('required')||
      this.CodigoEntidad.hasError('required')||
      this.CodigoEntidad.hasError('pattern')||
      (this.CodigoEntidad.value.length < 6||this.CodigoEntidad.value.length > 6)||
      this.RazonSocial.hasError('required')||
      this.RazonSocial.value.length < 5||
      this.RazonSocial.value.length > 100||
      this.CodigoDepto.hasError('required')||
      this.CodigoMpio.hasError('required')||
      this.Direccion.hasError('required')||
      this.Direccion.value.length < 10||
      this.Direccion.value.length > 100||
      this.Telefono.hasError('required')||
      this.Telefono.value.length < 7||
      this.Telefono.value.length > 22||
      this.CodigoEntidadFinanciadora.hasError('required')||
      (this.ResponsableChvNombre.hasError('required')&&this.AuxFuenteCHV.value)||
      (this.ResponsableChvNombre.value.length < 5 &&this.AuxFuenteCHV.value)||
      (this.ResponsableChvNombre.value.length > 100 &&this.AuxFuenteCHV.value)||
      (this.ResponsableChvCargo.hasError('required')&&this.AuxFuenteCHV.value)||
      (this.ResponsableChvCargo.value.length < 5 &&this.AuxFuenteCHV.value)||
      (this.ResponsableChvCargo.value.length > 100 &&this.AuxFuenteCHV.value)||
      (this.ResponsableChvTelefono.hasError('required')&&this.AuxFuenteCHV.value)||
      (this.ResponsableChvTelefono.value.length < 7 &&this.AuxFuenteCHV.value)||
      (this.ResponsableChvTelefono.value.length > 10 &&this.AuxFuenteCHV.value)||
      (this.ResponsableChvCorreo.hasError('required')&&this.AuxFuenteCHV.value)||
      (this.ResponsableChvCorreo.value.length < 5 &&this.AuxFuenteCHV.value)||
      (this.ResponsableChvCorreo.value.length > 40 &&this.AuxFuenteCHV.value)||
      ((this.ResponsableChvCorreo.hasError('email')||!this.checkEmailValidityChv())&&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvNombre.hasError('required')&&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvNombre.value.length < 5 &&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvNombre.value.length > 100 &&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvCargo.hasError('required')&&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvCargo.value.length < 5 &&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvCargo.value.length > 100 &&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvTelefono.hasError('required')&&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvTelefono.value.length < 7 &&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvTelefono.value.length > 10 &&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvCorreo.hasError('required')&&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvCorreo.value.length < 5 &&this.AuxFuenteCHV.value)||
      (this.ResponsableInfoChvCorreo.value.length > 40 &&this.AuxFuenteCHV.value)||
      ((this.ResponsableInfoChvCorreo.hasError('email')||!this.checkRespInfoEmailValidityChv())&&this.AuxFuenteCHV.value)||
      (this.ResponsableFiviNombre.hasError('required')&&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviNombre.value.length < 5 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviNombre.value.length > 100 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviCargo.hasError('required')&&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviCargo.value.length < 5 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviCargo.value.length > 100 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviTelefono.hasError('required')&&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviTelefono.value.length < 7 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviTelefono.value.length > 10 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviCorreo.hasError('required')&&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviCorreo.value.length < 5 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableFiviCorreo.value.length > 40 &&this.AuxFuenteFIVI.value)||
      ((this.ResponsableFiviCorreo.hasError('email')||!this.checkEmailValidityFivi())&&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviNombre.hasError('required')&&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviNombre.value.length < 5 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviNombre.value.length > 100 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviCargo.hasError('required')&&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviCargo.value.length < 5 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviCargo.value.length > 100 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviTelefono.hasError('required')&&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviTelefono.value.length < 7 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviTelefono.value.length > 10 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviCorreo.hasError('required')&&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviCorreo.value.length < 5 &&this.AuxFuenteFIVI.value)||
      (this.ResponsableInfoFiviCorreo.value.length > 40 &&this.AuxFuenteFIVI.value)||
      ((this.ResponsableInfoFiviCorreo.hasError('email')||!this.checkRespInfoEmailValidityFivi())&&this.AuxFuenteFIVI.value)
    ){
      return true;
    }else {
      return false;
    }
  }

  UpdateVariableNuevaFuente(){
    this.NuevaFuente.nit = this.Nit.value;
    this.NuevaFuente.codigoSuperintendencia = this.CodigoSuperintendencia.value;
    this.NuevaFuente.codigoTipoEntidad = this.CodigoTipoEntidad.value;
    this.NuevaFuente.codigoEntidad = this.CodigoEntidad.value;
    this.NuevaFuente.razonSocial = this.RazonSocial.value;
    this.NuevaFuente.codigoDepto = this.CodigoDepto.value;
    this.NuevaFuente.codigoMpio = this.CodigoMpio.value;
    this.NuevaFuente.telefono = this.Telefono.value;
    this.NuevaFuente.codigoEntidadFinanciadora = this.CodigoEntidadFinanciadora.value;
    this.NuevaFuente.responsableChvNombre = this.ResponsableChvNombre.value;
    this.NuevaFuente.responsableChvCargo = this.ResponsableChvCargo.value;
    this.NuevaFuente.responsableChvTelefono = this.ResponsableChvTelefono.value;
    this.NuevaFuente.responsableChvCorreo = this.ResponsableChvCorreo.value;
    this.NuevaFuente.responsableInfoChvNombre = this.ResponsableInfoChvNombre.value;
    this.NuevaFuente.responsableInfoChvCargo = this.ResponsableInfoChvCargo.value;
    this.NuevaFuente.responsableInfoChvTelefono = this.ResponsableInfoChvTelefono.value;
    this.NuevaFuente.responsableInfoChvCorreo = this.ResponsableInfoChvCorreo.value;
    this.NuevaFuente.responsableFiviNombre = this.ResponsableFiviNombre.value;
    this.NuevaFuente.responsableFiviCargo = this.ResponsableFiviCargo.value;
    this.NuevaFuente.responsableFiviTelefono = this.ResponsableFiviTelefono.value;
    this.NuevaFuente.responsableFiviCorreo = this.ResponsableFiviCorreo.value;
    this.NuevaFuente.responsableInfoFiviNombre = this.ResponsableInfoFiviNombre.value;
    this.NuevaFuente.responsableInfoFiviCargo = this.ResponsableInfoFiviCargo.value;
    this.NuevaFuente.responsableInfoFiviTelefono = this.ResponsableInfoFiviTelefono.value;
    this.NuevaFuente.responsableInfoFiviCorreo = this.ResponsableInfoFiviCorreo.value;
  }

  Complemento2(){
    this.acomple = this.acomple + " " + this.Komplemento.value + " ";
  }

  NormalizarDireccion2(){

    this.NuevaFuente.tipoViaPrincipal = this.TipoViaPrincipal.value;
    this.NuevaFuente.nombreViaPrincipal = this.NombreViaPrincipal.value;
    this.NuevaFuente.letraViaPrincipal = this.LetraViaPrincipal.value;
    this.NuevaFuente.prefijo = this.Prefijo.value;
    this.NuevaFuente.cuadrante1 = this.Cuadrante1.value;
    this.NuevaFuente.numeroPrefijo1 = this.NumeroPrefijo1.value;
    this.NuevaFuente.letraPrefijo = this.LetraPrefijo.value;
    this.NuevaFuente.numeroPrefijo2 = this.NumeroPrefijo2.value;
    this.NuevaFuente.cuadrante2 = this.Cuadrante2.value;
    this.NuevaFuente.complemento = this.Komplemento.value;
    this.NuevaFuente.numeroLetraComplemento = this.acomple;

    this.DireccionFinal = this.TipoViaPrincipal.value+' '+this.NombreViaPrincipal.value+' '+this.LetraViaPrincipal.value
                          +' '+this.Prefijo.value+' '+this.Cuadrante1.value+' '+this.NumeroPrefijo1.value+' '+this.LetraPrefijo.value
                          +' '+this.NumeroPrefijo2.value+' '+this.Cuadrante2.value+' '+this.acomple;

    this.NuevaFuente.direccion = this.DireccionFinal;
    this.Direccion.setValue(this.DireccionFinal);
    this.closeModalDireccion.nativeElement.click();
  }

  operacion : number = 0;
  GuardarNuevaFuente2(){
    this.btnguardar = true;
    if(this.AuxFuenteCHV.value&&!this.AuxFuenteFIVI.value) this.operacion = 1;
    if(!this.AuxFuenteCHV.value&&this.AuxFuenteFIVI.value) this.operacion = 2;
    if(this.AuxFuenteCHV.value&&this.AuxFuenteFIVI.value) this.operacion = 0;
    this.adminFuentesService.existeCodigoFuente(this.NuevaFuente.codigoSuperintendencia, this.NuevaFuente.codigoTipoEntidad, this.NuevaFuente.codigoEntidad, this.operacion).subscribe(Res1=>{
      if(Res1){
        let serviceMethod: string;

        if (this.AuxFuenteCHV.value && !this.AuxFuenteFIVI.value) {
          serviceMethod = 'crearFuenteChvNueva';
        } else if (!this.AuxFuenteCHV.value && this.AuxFuenteFIVI.value) {
          serviceMethod = 'crearFuenteFiviNueva';
        } else if (this.AuxFuenteCHV.value && this.AuxFuenteFIVI.value) {
          serviceMethod = 'crearFuenteChvFiviNueva';
        }

        if (serviceMethod) {
          this.adminFuentesService.crearFuenteNueva(this.NuevaFuente, serviceMethod).subscribe(
            Res2 => this.handleResponse(Res2),
            error => this.handleError()
          );
        }

      }else{
        this.btnguardar = false;
        this.toastr.warning('Código entidad ya existe.', 'Advertencia!');
      }
      this.cerrarmodalcargando.nativeElement.click();
    },error=>{
      this.toastr.error('Error.', 'Error!');
      this.cerrarmodalcargando.nativeElement.click();
    });
  }

  private readonly SUCCESS_MESSAGE = 'Fuente creada.';
  private readonly ERROR_MESSAGE = 'Error al crear la fuente.';

  private handleResponse = (Res2: any) => {
    if (Res2 != null) {
      this.toastr.success(this.SUCCESS_MESSAGE, 'OK!');
      this.openmodalAdminvar.nativeElement.click();
    } else {
      this.toastr.error(this.ERROR_MESSAGE, 'Error!');
    }
    this.cerrarmodalcargando.nativeElement.click();
  };

  private handleError = () => {
    this.toastr.error(this.ERROR_MESSAGE, 'Error!');
    this.cerrarmodalcargando.nativeElement.click();
  };

  GuardarNuevaFuente1(){
    this.openmodalcargando.nativeElement.click();
  }

  cerrarAdvertencia(){
    this.cerrarmodalAdminvar.nativeElement.click();
    this.router.navigate(['fuentes']);
  }


}
